"use client";
import { memo, type ReactElement } from "react";
import { motion } from "framer-motion";
import { Cteamcard } from "../Cteamcard";
import { CARD_FILL_STYLE, ENTRANCE_DURATION, ENTRANCE_EASE, ENTRANCE_STAGGER_DELAY_PER_PITCH, HERO_TEAM_CARD_BACKGROUND, HERO_TEAM_CARD_CONTENT_BACKDROP_BLUR, PERSPECTIVE_PX, } from "./constants";
import type { CarouselCardProps } from "./types";
import { useCarouselCardClickHandler } from "./useCarouselCardClickHandler";
import { useCarouselCardMotion } from "./useCarouselCardMotion";
export const CarouselCard = memo(function CarouselCard({ team, doubledIndex, scrollX, pitch, cardWidth, cardHeight, cardGap, cardContainerPreset, distanceFromCenter, entranceReady, isMobile, isCentered, onSelectTeam, onScrollToIndex, precomputedVendors, }: CarouselCardProps): ReactElement {
    const { compensateX, cylinderZ, opacity, rotateX, rotateY, scale } = useCarouselCardMotion({
        doubledIndex,
        pitch,
        scrollX,
    });
    const handleClick = useCarouselCardClickHandler({
        cardContainerPreset,
        doubledIndex,
        isCentered,
        onScrollToIndex,
        onSelectTeam,
        team,
    });
    const staggerDelay = distanceFromCenter * ENTRANCE_STAGGER_DELAY_PER_PITCH;
    const entranceVisible = { opacity: 1, filter: "blur(0px)", y: 0 };
    const entranceHidden = isMobile
        ? { opacity: 0, filter: "blur(0px)", y: 12 }
        : { opacity: 0, filter: "blur(8px)", y: 12 };
    return <motion.div data-el="Cteamscarousel/CarouselCard/Root" initial={entranceHidden} animate={entranceReady ? entranceVisible : entranceHidden} transition={{
            delay: staggerDelay,
            duration: ENTRANCE_DURATION,
            ease: ENTRANCE_EASE,
        }} style={{
            flexShrink: 0,
            width: cardWidth,
            height: cardHeight,
            marginRight: cardGap,
            scrollSnapAlign: "center",
            scrollSnapStop: "always",
            willChange: "opacity, transform",
        }}>
            <motion.div style={{
            width: "100%",
            height: "100%",
            scale,
            opacity,
            x: compensateX,
            rotateX,
            rotateY,
            z: cylinderZ,
            transformPerspective: PERSPECTIVE_PX,
            willChange: "transform, opacity",
        }}>
                <Cteamcard dataElScope="Cteamscarousel/CarouselCard" teamData={team} onClick={handleClick} fixedWidth={cardWidth} fixedHeight={cardHeight} cardContainerPreset={cardContainerPreset} cardBackground={HERO_TEAM_CARD_BACKGROUND} contentBackdropBlur={HERO_TEAM_CARD_CONTENT_BACKDROP_BLUR} useBackdropFilter={false} style={CARD_FILL_STYLE} precomputedVendors={precomputedVendors}/>
            </motion.div>
        </motion.div>
        ;
});
